/**
 * Stops an Escape that closes a dialog, popover or Select from reaching the
 * legacy ckds drawers (`EmbeddedDrawer`, `PushDrawer`), which close on any Escape
 * keydown that bubbles to `document`. Without it, one press closes the layer and
 * the drawer behind it.
 *
 * Pass it as `onEscapeKeyDown` on `DialogContent` / `AlertDialogContent`, on a
 * `PopoverContent` that opens over a drawer, and on any `SelectContent` inside
 * them: Radix calls it from its capture-phase listener
 * on `document`, so stopping propagation there keeps the event from ever reaching
 * the drawer's bubble-phase listener, and Radix still closes the layer. A React
 * `onKeyDown` can't do this: Radix has already closed the dialog by the time the
 * event reaches React, so the handler never runs.
 */
export function keepEscapeInDialog(event: KeyboardEvent) {
  event.stopPropagation();
}
